(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cheeky-video-laughs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cheeky-video-controller')) {
  class CheekyVideoController extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const root = this.closest('.shopify-section');
      const section = root.querySelector('.ck-laughs');
      const videos = [...root.querySelectorAll('.ck-laughs__video')];
      const visible = new Set();
      const userPaused = new Set();
      const update = video => {
        const screen = video.closest('.ck-laughs__screen');
        screen.setAttribute('aria-label', video.paused ? screen.dataset.playLabel : screen.dataset.pauseLabel);
        screen.setAttribute('aria-pressed', String(!video.paused));
      };
      const play = video => {
        if (document.hidden || userPaused.has(video)) return;
        video.muted = true;
        video.defaultMuted = true;
        if (!video.src) video.src = video.dataset.videoUrl;
        video.hidden = false;
        video.play().catch(() => update(video));
      };
      videos.forEach(video => {
        const card = video.closest('.ck-laughs__card');
        const screen = card.querySelector('.ck-laughs__screen');
        const toggle = () => {
          if (video.paused) { userPaused.delete(video); play(video); }
          else { userPaused.add(video); video.pause(); }
        };
        video.muted = true;
        video.defaultMuted = true;
        screen.addEventListener('click', toggle, {signal});
        screen.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
        }, {signal});
        video.addEventListener('playing', () => {
          const poster = card.querySelector('.ck-laughs__poster');
          if (poster) poster.hidden = true;
          update(video);
        }, {signal});
        video.addEventListener('pause', () => update(video), {signal});
        video.addEventListener('volumechange', () => { if (!video.muted) video.muted = true; }, {signal});
        video.addEventListener('error', () => { card.querySelector('.ck-laughs__error').hidden = false; update(video); }, {signal});
      });
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
        const video = entry.target.querySelector('video');
        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) { visible.add(video); play(video); }
        else { visible.delete(video); video.pause(); }
      }), {threshold:[0,0.25]});
      videos.forEach(video => this.observer.observe(video.closest('.ck-laughs__screen')));
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) videos.forEach(video => video.pause());
        else visible.forEach(play);
      }, {signal});
      const header = document.querySelector('.ck-head');
      const purchaseBar = document.querySelector('.ck-sticky');
      const fit = () => {
        const viewport = window.visualViewport?.height || window.innerHeight;
        const headHeight = header?.getBoundingClientRect().height || 0;
        const purchaseHeight = purchaseBar?.getBoundingClientRect().height || 0;
        // Reserve caption, spacing and the fixed purchase bar, even before it appears.
        const height = Math.max(96, Math.min(520, viewport - headHeight - purchaseHeight - 112));
        section.style.setProperty('--ck-video-fit-height', `${Math.floor(height)}px`);
      };
      fit();
      this.resize = new ResizeObserver(fit);
      [header,purchaseBar].filter(Boolean).forEach(element => this.resize.observe(element));
      window.addEventListener('resize', fit, {signal});
      window.visualViewport?.addEventListener('resize', fit, {signal});
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); }
  }
  customElements.define('cheeky-video-controller', CheekyVideoController);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cheekynook-tracking"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cn-tracking__form').forEach(form => {
    form.addEventListener('submit',event => {
      const number = form.elements.nums.value.trim();
      if (!number) return;
      event.preventDefault();
      window.location.assign('https://t.17track.net/en#nums=' + encodeURIComponent(number));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
